import { createSelectorFactory, defaultMemoize } from '@ngrx/store';

import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';
import type { Guest } from '@recruitee/notes-types';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<Guest>()(
  EntityStoreKey.guest,
  {
    customActions: adapter => ({
      references: (state, payload: { data: Guest[] }) =>
        adapter.updateOrCreateMany(state, payload.data),
    }),
  },
);

const byIds = memoizeSelector((guestIds: number[]) =>
  createSelectorFactory(defaultMemoize)(
    ...(guestIds || []).map(guestId => selectors.byId(guestId)),
    (...result: Guest[]) => result,
  ),
);

const byId = (id: number | null) => (id ? selectors.byId(id) : () => null);

const GuestSelectors = {
  ...selectors,
  byIds,
  byId,
};

export {
  actions as GuestActions,
  GuestSelectors,
  reducer as GuestReducer,
  namespace as GuestNamespace,
};
